import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import {Button, Card} from "react-bootstrap";

function JugendPage() {
    return (<>
        <Navbar/>
        <Card>
            <Card.Header>Kinder und Jugend</Card.Header>
            <Card.Body>
                <Card.Text>
                Durch unser erfahrenes Team von Übungsleitern, Tauchlehrern und Helfern ist es uns möglich, einen vielseitigen Mix von Schwimmhallentraining und Vereinsveranstaltungen für unsere Kinder und Jugendgruppe anzubieten.

                Wir versuchen unseren Jüngsten durch das wöchentliche Training, Wochenendveranstaltungen und Ausflüge in die Natur an den Tauchsport als aktive sportliche Freizeitgestaltung heranzuführen und für unseren bereichernden, wunderschönen Natursport zu begeistern.
                </Card.Text>
            </Card.Body>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>)

}

export default JugendPage;
